import { tns } from 'tiny-slider/src/tiny-slider';

(function () {
  const $els = document.querySelectorAll('[data-vanilla="news-slider"]');

  if (!$els.length) {
    return;
  }
  $els.forEach(($el) => {
    tns({
      container: $el.querySelector('.news-slider__container'),
      items: 1,
      center: false,
      autoplay: false,
      edgePadding: 10,
      autoplayButtonOutput: true,
      gutter: 20,
      loop: false,
      nav: true,
      lazyload: false,
      lazyloadSelector: '.news-card__cover img',
      slideBy: 'page',
      controls: false,
      controlsText: ['', ''],
      responsive: {
        640: {
          items: 2
        },
        991: {
          items: 3
        }
      }
    });
  });
})();
